import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').directive('pkpAuctionTermTable', pkpAuctionTermTable);

    /**
     * Auction Term table for NWP Detail and Dashboard "place a bid"
     *
     * @author sosoehng.prv
     * @ngInject
     */
    function pkpAuctionTermTable() {
        return {
            restrict: 'E',
            scope: {
                settings: '=',
                terms: '='
            },
            template:
                require('app/_directives/pkp-auction-term-table.directive.html'),
            controller: auctionTermCtrl
        };

        function auctionTermCtrl($scope, DATES, auctionsOverviewService) {
            $scope.terms = angular.copy($scope.terms);
            $scope.DATES = DATES;
            $scope.ACTION_TYPE = auctionsOverviewService.ACTION_TYPE;
        }
    }
})();
